export type GhGoalValueType = 'netZero' | 'carbon' | 'other';

export const ghGoalOptions: {
  value: GhGoalValueType;
  label: string;
}[] = [
  {
    value: 'netZero',
    label:
      'การตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกสุทธิเป็นศูนย์ (Net-Zero Greenhouse Gas Emissions)',
  },
  {
    value: 'carbon',
    label: 'การตั้งเป้าหมายความเป็นกลางทางคาร์บอน (Carbon Neutrality)',
  },
  {
    value: 'other',
    label: 'การตั้งเป้าหมายการลดก๊าซเรือนกระจกอื่น ๆ',
  },
];
